// extracted by mini-css-extract-plugin
export default {"main":"best_main__A7GQn","img":"best_img__Ap1rR","best":"best_best__iYhX1","content_best":"best_content_best__nBHTQ"};